<template>
<vx-card title="Loan Detail" class="mb-3" :class="(customer_uuid == '0' || customer_uuid == '') ? 'disableform' : '' ">
    <template slot="actions">
        <div class="loan-det" style="display:flex">
            <vs-button size="small" color="warning" type="border" v-show="!flag_edit && !flag_new && flag_has_loan_info && (permissions_update || permissions_create)" @click="toggle" icon="icon-edit" icon-pack="feather">{{ largeScreenWidth ? 'Edit' : '' }}</vs-button>
            <vs-button size="small" color="warning" type="filled" v-show="flag_edit && !flag_new && flag_has_loan_info && (permissions_update || permissions_create)" @click="cancelEdit" icon="icon-corner-down-left" icon-pack="feather">{{ largeScreenWidth ? 'Back' : '' }}</vs-button>
            <vs-button size="small" color="danger" type="filled" v-show="!flag_edit && !flag_new && flag_has_loan_info && (permissions_update || permissions_create)" class="ml-2" @click="cancelLoan" icon="icon-x" icon-pack="feather">{{ largeScreenWidth ? 'Cancel' : '' }}</vs-button>
            <vs-button size="small" color="primary" type="filled" v-show="flag_edit || flag_new || !flag_has_loan_info && (permissions_update || permissions_create)" class="ml-2" :disabled="(customer_uuid == '0' || customer_uuid == '') " @click="saveLoan" icon="icon-save" icon-pack="feather">{{ largeScreenWidth ? 'Save' : '' }}</vs-button>
        </div>

    </template>

    <div class="vx-row mt-3" v-if="false">
        <div class="vx-col w-full lg:w-1/4 md:w-1/3 sm:w-full mb-base" v-for="(item, index) in picture_list" :key="index">
            <vx-card class="attachments">
                <div style="position:relative;">
                    <vs-button radius color="danger" style="position:absolute; top:0" @click="delete_image(item.id, index)" v-if="permissions_update || permissions_create" icon-pack="feather" icon="icon-trash-2"></vs-button>
                    <img :alt="item.filename" :title="item.filename" style="height: 220px; width:100%; cursor:pointer" :src="item.url" @click="view_image(item.url)">
                </div>
            </vx-card>
        </div>
        <div class="vx-col w-full lg:w-1/4 md:w-1/3 sm:w-full mb-base" :key="picture_list.length + 1" v-show="permissions_update || permissions_create">
            <vx-card class="attachments">
                <vue-dropzone style="height: 220px; width:100%;" id="dropzone" ref="myVueDropzone" :use-custom-slot="true" :options="dropzoneOptions" @vdropzone-sending="sendingEvent" @vdropzone-complete="afterComplete">
                    <div class="dropzone-custom-content">
                        <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                        <h4>Drop files here or click to upload.</h4>
                    </div>
                </vue-dropzone>
            </vx-card>
        </div>
    </div>
    <div class="vx-col sm:w-full w-full mb-2">
        <vs-input :disabled="!flag_edit && !flag_new" class="w-full" label-placeholder="Account No/卡号" v-model="loan_info.account_no" />
    </div>
    <div class="vx-col w-full lg:w-1/2 mb-2">
        <datepicker :disabled="!flag_edit && !flag_new" style="padding-top:1.1rem" :monday-first="true" placeholder="Loan Date/贷款日期" class="w-full" v-model="loan_info.myDate" format="yyyy-MM-dd" @input="loan_info.loan_date = fixDate($event)"></datepicker>
    </div>
    <div class="vx-col w-full lg:w-1/2 mb-2" v-show="user_info.role == 'SUPERADMIN' || user_info.role == 'DEVELOPER' " :class="( (user_info.role == 'SUPERADMIN' || user_info.role == 'DEVELOPER') && largeScreenWidth ) ? 'margintop' : '' ">
        <vs-select autocomplete :disabled="!flag_edit && !flag_new" v-model="loan_info.groupid" label="Group/群" class="w-full mb-2">
            <vs-select-item :key="index" :value="item.groupid" :text="item.name" v-for="(item,index) in groupid_list" />
        </vs-select>
    </div>
    </div>
    <div class="vx-row">
        <div class="vx-col w-full lg:w-1/2 mb-2">
            <vs-input :disabled="!flag_edit && !flag_new" class="w-full" label-placeholder="Collector/收数人" v-model="loan_info.loan_collector" />
        </div>
        <div class="vx-col w-full lg:w-1/2 mb-2">
            <vs-input :disabled="!flag_edit && !flag_new" class="w-full" label-placeholder="Site Visit/看屋子" v-model="loan_info.site_visit" />
        </div>
    </div>
    <div class="vx-row">
        <div class="vx-col w-full lg:w-1/2 mb-6">
            <vs-input :disabled="!flag_edit && !flag_new" class="w-full" label-placeholder="Payment Method/付款方式" v-model="loan_info.payment_method" />
        </div>
        <div class="vx-col w-full lg:w-1/2 mb-2">
            <vs-input :disabled="!flag_edit && !flag_new" class="w-full" label-placeholder="Bank Account/银行户口" v-model="loan_info.bank_account" />
        </div>
    </div>
    <div class="vx-row">
        <div class="vx-col w-full mb-6">
            <vs-textarea :disabled="!flag_edit && !flag_new" :readonly="!flag_edit && !flag_new" label="Remark/备注" v-model="loan_info.remark" class="w-full" />
        </div>
    </div>

    <div class="vx-row">
        <div class="vx-col w-full md:w-1/3 lg:w-1/4 xl:w-1/5 mb-4">
            <vs-input :disabled="!flag_edit && !flag_new" type="number" class="w-full" label-placeholder="Loan/贷款" v-model="loan_info.loan_amount" v-on:blur="printConsole('loan_amount')" @change="autoCalculate" />
        </div>
        <div class="vx-col w-full md:w-1/3 lg:w-1/4 xl:w-1/5 mb-4">
            <vs-input :disabled="!flag_edit && !flag_new" type="number" class="w-full" label-placeholder="Deposit/定金" v-model="loan_info.loan_deposit" v-on:blur="printConsole('loan_deposit')" @change="autoCalculate" />
        </div>
        <div class="vx-col w-full md:w-1/3 lg:w-1/4 xl:w-1/5 mb-4">
            <vs-input :disabled="!flag_edit && !flag_new" type="number" v-on:blur="printConsole('loan_process_fee')" class="w-full" label-placeholder="Process Fee/手续费" v-model="loan_info.loan_process_fee" @change="autoCalculate" />
        </div>
        <div class="vx-col w-full md:w-1/3 lg:w-1/4 xl:w-1/5 mb-4">
            <vs-input :disabled="!flag_edit && !flag_new" v-on:blur="printConsole('loan_capital')" type="number" class="w-full" label-placeholder="Capital/支出" v-model="loan_info.loan_capital" />
        </div>
        <div class="vx-col w-full md:w-1/3 lg:w-1/4 xl:w-1/5 mb-4">
            <vs-input :disabled="!flag_edit && !flag_new" v-on:blur="printConsole('loan_settlement')" type="number" class="w-full" label-placeholder="Settlement/结算贷款" v-model="loan_info.loan_settlement" />
        </div>
    </div>

    <div class="vx-row">
        <div class="vx-col w-full md:w-1/3 lg:w-1/4 xl:w-1/5 mb-4">
            <vs-input :disabled="!flag_edit && !flag_new" v-on:blur="printConsole('bonus_percent')" type="number" class="w-full" label-placeholder="Bonus Percentage/佣金花红" v-model="loan_info.bonus_percent" />
        </div>
    </div>
    <vs-popup title="Loan Picture" :active.sync="flag_showImage" class="img-detail">
      <img style="max-width:100%" :src="viewed_image_url">
    </vs-popup>
</vx-card>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import moment from 'moment'
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import imageCompressor from 'vue-image-compressor'

export default {
    name: 'Detail',
    props: {
        customer_uuid: {
            type: String,
            default: '0'
        },
        loan_uuid: {
            type: String,
            default: '0'
        },
        isEdit: {
            type: Boolean,
            default: false
        },
    },
    components: {
        Datepicker,
        vueDropzone: vue2Dropzone,
        imageCompressor,
    },
    data() {
        return {
            dropzoneOptions: {
                // url: "https://httpbin.org/post",
                url: process.env.VUE_APP_GLOBALURL + '/pictures',
                thumbnailWidth: 150,
                thumbnailHeight: 150,
                maxThumbnailFilesize: 1,
                maxFilesize: 11,
                maxFiles: 6,
                parallelUploads: 1,
                autoDiscover: false,
                uploadMultiple: true,
                autoProcessQueue: true,
                // autoProcessQueue: true,
                acceptedFiles: ".jpeg,.jpg,.png,.gif",
                // forceFallback: true,
                headers: {
                    'Cache-Control': null,
                    'X-Requested-With': null,
                    Authorization: "Bearer " + sessionStorage.getItem('accessToken')
                },
                addRemoveLinks: true
            },
            picture_list: [],
            queue_list: 0,
            flag_new: true,
            flag_has_loan_info: false,
            flag_edit: false,

            loan_info: {
                groupid: '',
                account_no: '',
                myDate: new Date(),
                loan_date: moment(new Date()).format('YYYY-MM-DD'),
                loan_status: '',
                loan_collector: '',
                site_visit: '',
                payment_method: '',
                bank_account: '',
                loan_amount: '0',
                loan_deposit: '0',
                loan_process_fee: '0',
                loan_capital: '0',
                loan_settlement: '0',
                remark: '',
                bonus_percent: '0',
            },
            backup_loan_info_data: {},
            backup_loan_uuid: '',
            viewed_image_url: '',
            flag_showImage: false
        }
    },
    watch: {
        loan_uuid() {
            this.resetall()
            if (this.loan_uuid !== '' && this.loan_uuid !== 'new') {
                this.backup_loan_uuid = this.loan_uuid
                this.load_detail(this.loan_uuid)
                this.load_image(this.loan_uuid)
            } else {
                this.flag_new = true
            }
        }
    },
    computed: {
        permissions() {
            if (this.$store.state.AppActiveUser && this.$store.state.AppActiveUser.permissions) {
                return this.$store.state.AppActiveUser.permissions;
            } else {
                return []
            }
        },
        permissions_create() {
            if (this.permissions.includes('*') || this.permissions.includes('031')) {
                return true
            } else {
                return false
            }
        },
        permissions_list() {
            if (this.permissions.includes('*') || this.permissions.includes('032')) {
                return true
            } else {
                return false
            }
        },
        permissions_update() {
            if (this.permissions.includes('*') || this.permissions.includes('033')) {
                return true
            } else {
                return false
            }
        },
        permissions_delete() {
            if (this.permissions.includes('*') || this.permissions.includes('034')) {
                return true
            } else {
                return false
            }
        },
        largeScreenWidth() {
            if (window.innerWidth > 575) {
                return true
            } else
                return false
        },
        users() {
            return this.$store.state.userManagement.users
        },
        groupid_list() {
            let self = this
            let temp = []

            this.users.forEach(function (item) {
                if (item.role !== 'WORKER') {
                    temp.push({
                        groupid: item.groupid,
                        name: item.name
                    })
                }
            })

            return temp
        },
        user_info() {
            let data = JSON.parse(sessionStorage.getItem('userInfo'));
            return data
        },
    },
    methods: {
        removeAllFiles() {
            this.$refs.myVueDropzone.removeAllFiles();
        },
        trigger_event() {
            if (this.$refs.myVueDropzone.getQueuedFiles().length > 0) {
                this.$vs.loading()
                this.$refs.myVueDropzone.processQueue();
            }
        },
        sendingEvent(file, xhr, formData) {
            console.log(file, xhr, formData);
            let uuid = this.$route.params.loan_id
            formData.append("loan_uuid", uuid);
            formData.append("loan_picture", file);
        },
        afterComplete() {
            console.log('afterComplete')
            this.$refs.myVueDropzone.removeAllFiles();
            this.picture_list = []
            this.load_image(this.backup_loan_uuid)
        },
        //image function
        view_image(image_url) {
            let self = this
            this.viewed_image_url = image_url
            self.flag_showImage = true
        },
        load_image(loan_id) {
            console.log('load_image', loan_id)
            if (!loan_id) return false
            let self = this
            const baseURI = 'pictures/list'
            let formData = new FormData();
            formData.append('loan_uuid', loan_id);
            self.picture_list = []
            self.$http.post(baseURI, formData)
                .then((result) => {
                    if (result.data.status == 'success') {
                        console.log('load_image', result.data.data)
                        self.picture_list = result.data.data
                        self.$vs.loading.close()
                    }
                })
        },
        delete_image(img_id, index) {
            let self = this
            var a = confirm('Delete this?')
            if (a) {
                this.$vs.loading()
                const baseURI = 'pictures/' + img_id
                self.$http.delete(baseURI)
                    .then((result) => {
                        if (result.data.status == 'success') {
                            this.$vs.notify({
                                color: 'success',
                                title: 'Image Removed',
                                text: 'The selected attachment was successfully removed'
                            })
                            self.picture_list.splice(index, 1)
                            this.$vs.loading.close()
                        }
                    })
            }
        },
        resetall() {
            this.loan_info = {
                groupid: '',
                account_no: '',
                myDate: new Date(),
                loan_date: moment(new Date()).format('YYYY-MM-DD'),
                loan_status: '',
                loan_collector: '',
                site_visit: '',
                payment_method: '',
                bank_account: '',
                loan_amount: '0',
                loan_deposit: '0',
                loan_process_fee: '0',
                loan_capital: '0',
                loan_settlement: '0',
                remark: '',
            }
            this.backup_loan_info_data = {}
        },
        fixDate(event) {
            return moment(event).format('YYYY-MM-DD');
        },
        // LOAN PART
        toggle() {
            this.flag_edit = true
            this.backup_loan_info_data = JSON.parse(JSON.stringify(this.loan_info));
        },
        cancelEdit() {
            this.flag_edit = false
            this.loan_info = JSON.parse(JSON.stringify(this.backup_loan_info_data));
        },
        saveLoan() {
            let self = this
            let baseURI = ''
            if (self.loan_info.groupid == '' || self.loan_info.groupid == undefined || self.loan_info.groupid == 'undefined') {
                self.$vs.notify({
                    color: 'warning',
                    title: 'Group',
                    text: 'Please do not leave group empty'
                })
                return false
            }
            let formData = new FormData();
            if (self.flag_new) {
                baseURI = `loans`;

                let user = JSON.parse(sessionStorage.getItem('userInfo'));
                formData.append('customer_uuid', self.customer_uuid);
                formData.append('user_uuid', user.id);
                formData.append('account_no', self.loan_info.account_no);
                formData.append('loan_date', self.loan_info.loan_date);
                formData.append('payment_method', self.loan_info.payment_method);
                formData.append('bank_account', self.loan_info.bank_account);
                formData.append('loan_status', 'ACTIVE');
                formData.append('loan_collector', self.loan_info.loan_collector);
                formData.append('site_visit', self.loan_info.site_visit);
                formData.append('loan_amount', self.loan_info.loan_amount || 0);
                formData.append('loan_deposit', self.loan_info.loan_deposit || 0);
                formData.append('loan_process_fee', self.loan_info.loan_process_fee || 0);
                formData.append('loan_capital', self.loan_info.loan_capital || 0);
                formData.append('loan_settlement', self.loan_info.loan_settlement || 0);
                formData.append('bonus_percent', self.loan_info.bonus_percent || 0);
                formData.append('groupid', self.loan_info.groupid)
                formData.append('remark', self.loan_info.remark);
            } else {
                baseURI = `loans/${self.loan_uuid}`;

                formData.append('_method', 'PUT')
                formData.append('account_no', self.loan_info.account_no);
                formData.append('loan_date', self.loan_info.loan_date);
                formData.append('payment_method', self.loan_info.payment_method);
                formData.append('bank_account', self.loan_info.bank_account);
                formData.append('loan_status', self.loan_info.loan_status);
                // formData.append('loan_type', self.loan_info.loan_type);
                formData.append('loan_collector', self.loan_info.loan_collector);
                formData.append('site_visit', self.loan_info.site_visit);
                formData.append('loan_amount', self.loan_info.loan_amount || 0);
                formData.append('loan_deposit', self.loan_info.loan_deposit || 0);
                formData.append('loan_process_fee', self.loan_info.loan_process_fee || 0);
                formData.append('loan_capital', self.loan_info.loan_capital || 0);
                formData.append('loan_settlement', self.loan_info.loan_settlement || 0);
                formData.append('bonus_percent', self.loan_info.bonus_percent || 0);
                formData.append('groupid', self.loan_info.groupid)
                formData.append('remark', self.loan_info.remark);
            }

            self.$vs.loading()
            self.$http.post(baseURI, formData)
                .then((result) => {
                    if (result.data.status == 'success') {
                        self.$vs.loading.close()
                        if (self.loan_uuid == 'new') {
                            self.$vs.notify({
                                color: 'success',
                                title: 'Loan Created',
                                text: 'This loan successfully created'
                            })
                            this.$store.commit('setMutationPercent', self.loan_info.bonus_percent); // Correct
                            self.resetall()
                            self.$emit("updateLoan", result.data.data.id)
                        } else {
                            self.$vs.notify({
                                color: 'success',
                                title: 'Loan Updated',
                                text: 'This loan successfully updated'
                            })
                            this.$store.commit('setMutationPercent', self.loan_info.bonus_percent); // Correct
                            self.backup_loan_info_data = JSON.parse(JSON.stringify(self.loan_info));
                            self.cancelEdit()
                        }

                        // if(self.flag_new){
                        //   console.log('flag new ',result.data)
                        //   self.$router.replace(`/loan_detail/${result.data.data.id}`).catch(() => {})
                        //   self.load_detail(result.data.data.id)

                        //   // setTimeout(function(){
                        //   //   //scroll to bottom smoothly
                        //   //   window.scroll({
                        //   //     top: 1000,
                        //   //     behavior: 'smooth'
                        //   //   });
                        //   // },1000)
                        // }
                        // else{
                        //   self.backup_loan_info_data = JSON.parse(JSON.stringify(self.loan_info));
                        //   self.cancelEdit()
                        // }
                    }
                })
        },
        cancelLoan() {
            let self = this
            if (this.loan_uuid !== 'new' && !this.flag_new) {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: 'Confirm Delete',
                    text: `You are about to delete this loan?`,
                    acceptText: 'Confirm',
                    accept: function () {
                        self.$vs.loading()
                        const baseURI = 'loans/' + self.loan_uuid
                        self.$http.delete(baseURI)
                            .then((result) => {
                                if (result.data.status == 'success') {
                                    self.loan_info = {
                                        account_no: '',
                                        myDate: '',
                                        loan_date: '',
                                        loan_status: '',
                                        loan_collector: '',
                                        site_visit: '',
                                        payment_method: '',
                                        bank_account: '',
                                        loan_amount: '0',
                                        loan_deposit: '0',
                                        loan_process_fee: '0',
                                        loan_capital: '0',
                                        loan_settlement: '0',
                                        bonus_percent: '0',
                                        remark: '',
                                    }
                                    this.$store.commit('setMutationPercent', self.loan_info.bonus_percent); // Correct
                                    self.$vs.notify({
                                        color: 'success',
                                        title: 'Loan Updated',
                                        text: 'Loan successfully cancelled'
                                    })
                                    self.$vs.loading.close()
                                    self.flag_edit = true
                                    self.flag_has_loan_info = false
                                    self.$emit("updateLoan", 'new')
                                    self.resetall()
                                }
                            })
                    }
                })
            }
        },
        printConsole(target) {
            let self = this
            if (target == 'loan_amount') {
                if (self.loan_info.loan_amount !== '') {
                    self.loan_info.loan_amount = parseFloat(self.loan_info.loan_amount).toFixed(2)
                } else {
                    self.loan_info.loan_amount = '0'
                }

            } else if (target == 'loan_deposit') {
                if (self.loan_info.loan_deposit !== '') {
                    self.loan_info.loan_deposit = parseFloat(self.loan_info.loan_deposit).toFixed(2)
                } else {
                    self.loan_info.loan_deposit = '0'
                }

            } else if (target == 'loan_process_fee') {
                if (self.loan_info.loan_process_fee !== '') {
                    self.loan_info.loan_process_fee = parseFloat(self.loan_info.loan_process_fee).toFixed(2)
                } else {
                    self.loan_info.loan_process_fee = '0'
                }

            } else if (target == 'loan_capital') {
                if (self.loan_info.loan_capital !== '') {
                    self.loan_info.loan_capital = parseFloat(self.loan_info.loan_capital).toFixed(2)
                } else {
                    self.loan_info.loan_capital = '0'
                }

            } else if (target == 'loan_settlement') {
                if (self.loan_info.loan_settlement !== '') {
                    self.loan_info.loan_settlement = parseFloat(self.loan_info.loan_settlement).toFixed(2)
                } else {
                    self.loan_info.loan_settlement = '0'
                }
            } else if (target == 'bonus_percent') {
                if (self.loan_info.bonus_percent !== '') {
                    self.loan_info.bonus_percent = parseFloat(self.loan_info.bonus_percent).toFixed(2)
                } else {
                    self.loan_info.bonus_percent = '0'
                }
            }
        },
        autoCalculate() {
            if (this.loan_info.loan_amount !== '' && this.loan_info.loan_process_fee !== '' && this.loan_info.loan_deposit !== '') {

                let initial = parseFloat(this.loan_info.loan_amount)
                let fee = parseFloat(this.loan_info.loan_process_fee)
                let deposit = parseFloat(this.loan_info.loan_deposit)

                if ((initial - fee - deposit) < 0) {
                    //capital negative value
                    // this.flag_invalid = true
                    this.$vs.notify({
                        color: 'warning',
                        title: 'Loan Invalid ',
                        text: 'Capital cannot below 0'
                    })
                    this.loan_info.loan_capital = "0"
                    return false
                } else {
                    this.loan_info.loan_capital = (initial - fee - deposit).toFixed(2)
                }
            }
        },
        load_detail(loan_id) {
            let self = this
            const baseURI = 'loans/' + loan_id
            self.$vs.loading()
            self.$http.get(baseURI)
                .then((result) => {
                    self.$vs.loading.close()
                    console.log('result', result)
                    if (result.data.status == 'success') {
                        self.flag_has_loan_info = true
                        self.loan_info = result.data.data
                        sessionStorage.setItem('loan_info', self.loan_info);
                        this.$store.commit('setMutationPercent', self.loan_info.bonus_percent); // Correct
                        self.groupid = self.loan_info.groupid
                        self.customer_uuid = self.loan_info.customer_uuid
                        setTimeout(function () {
                            self.loan_account = self.loan_info.uuid
                        }, 500)

                        if (self.loan_info.loan_date && self.loan_info.loan_date !== '') {
                            self.loan_info.myDate = new Date(moment(self.loan_info.loan_date, 'YYYY-MM-DD'))
                        }

                        self.flag_edit = false
                        self.flag_new = false
                    } else {
                        self.flag_edit = true
                        self.flag_has_loan_info = false
                    }
                }).catch(err => {
                    if (err.logout) {
                        self.$vs.loading.close()
                        self.$vs.notify({
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger',
                            title: err.msg
                        })
                        sessionStorage.removeItem('accessToken')
                        sessionStorage.removeItem('user')
                        sessionStorage.removeItem('loan_info')
                        self.$router.push('/pages/login').catch(() => {})
                    }
                })
        }
    },
    created() {
        let self = this
        // setTimeout(function(){
        //   self.$emit("updateLoan", 'new')
        //   // self.loan_uuid = 'new'
        // },4000)

    }
}
</script>
